import { Icon, Text } from '@qcx/ui';
import { Link } from '../../../components/Link';
import { faDownload } from '@fortawesome/pro-regular-svg-icons';

export interface DownloadButtonProps {
  buttonText: string;
  buttonLink: string;
}

export const DownloadButton = ({
  buttonText,
  buttonLink
}: DownloadButtonProps) => (
  <Link
    css={{
      d: 'block',
      py: '$4',
      px: '$6',
      mb: '$4',
      bgColor: '$surface',
      rounded: '$lg',
      flexRowCenter: true,
      maxW: 722,
      '&:hover': {
        bgColor: '$neutral800'
      }
    }}
    className="dark"
    to={buttonLink}
  >
    <Icon
      css={{ color: '$hiContrast', mr: '$2' }}
      icon={faDownload}
      size="md"
    />
    <Text
      css={{
        color: '$hiContrast',
        mr: 'auto'
      }}
      variant="md"
      weight="semibold"
    >
      Baixe o Edital do Concurso {buttonText}
    </Text>
    <svg
      width="32"
      height="32"
      fill="none"
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M31.9919 16C31.9919 7.16237 24.8295 0 15.9919 0C7.17855 0 0.0242792 7.12999 0 15.9433H5.33333C5.36571 10.0759 10.1244 5.33333 16 5.33333C21.8918 5.33333 26.6667 10.1082 26.6667 16C26.6667 21.8756 21.9241 26.6343 16.0567 26.6667V26.6829V32C19.1806 31.9919 22.1022 31.0855 24.5625 29.5235L32 32L29.5235 24.5625C31.0855 22.086 31.9919 19.1482 31.9919 16Z"
        fill="#ffffff"
      />
    </svg>
  </Link>
);
